import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth, isAdmin } from "@/lib/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import IlNostroApproccio from "@/pages/IlNostroApproccio";
import CosaFacciamo from "@/pages/CosaFacciamo";
import Progetti from "@/pages/Progetti";
import ProgettoDetail from "@/pages/ProgettoDetail";
import Eventi from "@/pages/Eventi";
import EventoDetail from "@/pages/EventoDetail";
import Partecipa from "@/pages/Partecipa";
import Storie from "@/pages/Storie";
import Contatti from "@/pages/Contatti";
import Accedi from "@/pages/Accedi";
import Registrati from "@/pages/Registrati";
import VerificaEmail from "@/pages/VerificaEmail";
import RecuperaPassword from "@/pages/RecuperaPassword";
import ResetPassword from "@/pages/ResetPassword";
import AreaRiservata from "@/pages/AreaRiservata";
import RetiCollaborazioni from "@/pages/RetiCollaborazioni";
import EntraNellaComunita from "@/pages/EntraNellaComunita";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import BookingCancel from "@/pages/BookingCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import EventsAdmin from "@/pages/admin/EventsAdmin";
import BookingsAdmin from "@/pages/admin/BookingsAdmin";
import ProjectsAdmin from "@/pages/admin/ProjectsAdmin";
import ArticlesAdmin from "@/pages/admin/ArticlesAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import PartnersAdmin from "@/pages/admin/PartnersAdmin";
import UsersAdmin from "@/pages/admin/UsersAdmin";

function RequireAdmin({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user || !isAdmin(user.role)) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/il-nostro-approccio" element={<IlNostroApproccio />} />
            <Route path="/cosa-facciamo" element={<CosaFacciamo />} />
            <Route path="/accedi" element={<Accedi />} />
            <Route path="/registrati" element={<Registrati />} />
            <Route path="/verifica-email/:token" element={<VerificaEmail />} />
            <Route path="/recupera-password" element={<RecuperaPassword />} />
            <Route path="/reimposta-password/:token" element={<ResetPassword />} />
            <Route path="/area-riservata" element={<AreaRiservata />} />
            <Route path="/reti-e-collaborazioni" element={<RetiCollaborazioni />} />
            <Route path="/entra-nella-comunita" element={<EntraNellaComunita />} />
            <Route path="/progetti" element={<Progetti />} />
            <Route path="/progetti/:slug" element={<ProgettoDetail />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/eventi/:slug" element={<EventoDetail />} />
            <Route path="/partecipa" element={<Partecipa />} />
            <Route path="/storie" element={<Storie />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookie" element={<CookiePolicy />} />
            <Route path="/prenotazione/annulla/:token" element={<BookingCancel />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
            <Route index element={<Dashboard />} />
            <Route path="eventi" element={<EventsAdmin />} />
            <Route path="prenotazioni" element={<BookingsAdmin />} />
            <Route path="progetti" element={<ProjectsAdmin />} />
            <Route path="articoli" element={<ArticlesAdmin />} />
            <Route path="gallery" element={<GalleryAdmin />} />
            <Route path="partner" element={<PartnersAdmin />} />
            <Route path="utenti" element={<UsersAdmin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
